import React from "react";
import R from "ramda";
import { useLocalStorage } from "react-use";
import { useCookie } from "react-recipes";

import { useUsers } from "hooks";
import { externalRoutes } from "routes";
import UserPresenter from "presenters/UserPresenter";
import LocationInfoRepository from "repositories/LocationInfoRepository";

import useStyles from "./useStyles";

const CaliforniaDataLink = () => {
  const classes = useStyles();
  const { currentUser } = useUsers();
  const [locationInfo, setLocationInfo] = useLocalStorage("userLocationInfo", {});
  const [cookieUserLocationInfo] = useCookie("ccpa_info", false);

  if (R.isEmpty(locationInfo)) {
    if (cookieUserLocationInfo) {
      setLocationInfo(JSON.parse(cookieUserLocationInfo));
    } else {
      LocationInfoRepository.get().then((data) => {
        setLocationInfo(data.data);
      });
    }
  }

  const isCaliforniaUser = R.propEq("country", "US") && R.propEq("subdivision", "CA");

  return isCaliforniaUser(locationInfo) ? (
    <div className={classes.californiaDataLink}>
      <a
        href={
          UserPresenter.isRegistered(currentUser)
            ? externalRoutes.californiaDataLinkPath(currentUser.email)
            : externalRoutes.californiaDataLinkPath()
        }
        target="_blank"
        rel="noreferrer"
      >
        Do Not Sell My Personal Data
      </a>
    </div>
  ) : (
    <></>
  );
};

export default CaliforniaDataLink;
